import React, { useEffect } from 'react';
import { Col, Form, Select } from 'antd';
import { commonProps } from '../../../../../common/types/commonTypes';
import { useLazyGetAllTourInvoiceByIDQuery } from '../../../Api/Endpoints/TourPackageRefundEndpoints';

type PropsType = {
  clientID: string;
} & commonProps;

export const SelectTourInvoiceByClientID = ({
  name,
  label,
  size,
  required,
  disabled,
  clientID,
}: PropsType) => {
  const [fetchTourInvoice, { data: tourInvoiceByClientID }] =
    useLazyGetAllTourInvoiceByIDQuery();

  useEffect(() => {
    clientID && fetchTourInvoice(clientID);
  }, [clientID]);

  const selectTourInvoiceData = tourInvoiceByClientID?.data;
  const tourInvoiceDataChildren: React.ReactNode[] = [];
  if (selectTourInvoiceData) {
    for (let i = 0; i < selectTourInvoiceData.length; i++) {
      tourInvoiceDataChildren.push(
        <Select.Option
          key={selectTourInvoiceData[i].invoice_id}
          value={selectTourInvoiceData[i].invoice_id}
        >
          {`${selectTourInvoiceData[i].invoice_no}`}
        </Select.Option>
      );
    }
  }
  return (
    <Col span={6} xs={24} sm={24} md={24} lg={size ? size : 8}>
      <Form.Item
        name={name}
        label={label}
        rules={[
          {
            required: required,
            message: 'Select Tour Package Invoice is required',
          },
        ]}
      >
        <Select
          allowClear
          disabled={disabled}
          placeholder={'Select Tour Package Invoice'}
          showSearch
          style={{ padding: '0', margin: '0', border: '0' }}
          optionFilterProp='roleMobile'
          filterOption={(input, option) =>
            (option!.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        >
          {tourInvoiceDataChildren}
        </Select>
      </Form.Item>
    </Col>
  );
};
